/*=========================================================================================
  File Name: moduleMessagerieActions.js
  Description: Messagerie Module Actions
==========================================================================================*/

import messagingServices from '@/services/messaging.services';

export default {
  async fetchConversations({ commit, dispatch, state }) {
    commit('SET_LOADING', true);
    try {
      const { data } = await messagingServices.getConversations();
      commit('SET_CONVERSATIONS', data);
      if (!state.activeConversationId && data.length)
        await dispatch('selectConversation', data[0].id);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async startConversation({ commit, dispatch, state }, clientId) {
    const { data } = await messagingServices.startConversation(clientId);
    if (!state.conversations.find(c => c.id === data.id))
      commit('SET_CONVERSATIONS', [data, ...state.conversations]);
    await dispatch('selectConversation', data.id);
    return data;
  },

  async selectConversation({ commit, dispatch }, conversationId) {
    commit('SET_ACTIVE', conversationId);
    await dispatch('fetchMessages', conversationId);
    await dispatch('markRead', conversationId);
  },

  async fetchMessages({ commit }, conversationId) {
    const { data } = await messagingServices.getMessages(conversationId);
    commit('SET_MESSAGES', data.items);
  },

  async sendMessage({ commit, dispatch, state }, { body, files }) {
    const conversationId = state.activeConversationId;
    if (!conversationId) return;

    commit('SET_SENDING', true);
    try {
      const attachmentIds = [];
      for (const file of (files || [])) {
        const { data } = await messagingServices.uploadAttachment(conversationId, file);
        attachmentIds.push(data.id);
      }
      const { data: message } = await messagingServices.sendMessage(conversationId, body, attachmentIds);
      commit('ADD_MESSAGE', message);
      await dispatch('fetchUnreadCount');
    } finally {
      commit('SET_SENDING', false);
    }
  },

  async markRead({ commit, dispatch }, conversationId) {
    await messagingServices.markRead(conversationId);
    commit('SET_CONVERSATION_UNREAD', { id: conversationId, count: 0 });
    await dispatch('fetchUnreadCount');
  },

  async fetchUnreadCount({ commit }) {
    const { data } = await messagingServices.getTotalUnread();
    commit('SET_UNREAD', data);
  },

  async fetchContactableClientsCount({ commit }) {
    const { data } = await messagingServices.getContactableClientsCount();
    commit('SET_CONTACTABLE_COUNT', data.count);
  },

  startPolling({ commit, dispatch, state }) {
    dispatch('stopPolling');
    const timer = setInterval(() => {
      if (state.activeConversationId)
        dispatch('fetchMessages', state.activeConversationId).catch(() => {});
      dispatch('fetchUnreadCount').catch(() => {});
    }, 15000);
    commit('SET_POLL_TIMER', timer);
  },

  stopPolling({ commit, state }) {
    if (state.pollTimer) {
      clearInterval(state.pollTimer);
      commit('SET_POLL_TIMER', null);
    }
  },
};
